import { useDispatch } from 'react-redux';
import { bankRaw, unbankRaw } from 'api/raw-banks';
import { newsroomError } from 'api/newsroom';
import {
    handleHidePopup,
    handleShowPopup,
    setPopupConfig,
    setPopupLoading,
} from 'store/ux';

// The copy the newsdesk asked for, word for word: banking is a head start, not secrecy.
const BANK_COPY =
    'It comes off the Newspage archive so other journalists can&rsquo;t find it here while you write. ' +
    'The alert page itself stays public. You can hold two at a time. Please only bank a Raw you intend ' +
    'to run: while it&rsquo;s banked it&rsquo;s out of public view, and if it doesn&rsquo;t run that&rsquo;s ' +
    'a story nobody gets.';

const UNBANK_COPY =
    'It goes back into the Newspage archive straight away, where other journalists can find and bank it. ' +
    'Each Raw can be banked once, so you won&rsquo;t be able to bank it again.';

// "Fri 14:05": a bank lasts a day, so the weekday tells today from tomorrow.
export const releaseTime = (iso) =>
    new Date(iso).toLocaleString('en-GB', {
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
    });

export const useBankRaw = () => {
    const dispatch = useDispatch();

    return (alertId, { onBanked, onError }) => {
        dispatch(
            setPopupConfig({
                title: 'Bank this Raw for 24 hours',
                body: BANK_COPY,
                confirmTitle: 'Bank it',
                cancelTitle: 'Cancel',
                onConfirm: async () => {
                    dispatch(setPopupLoading(true));
                    try {
                        onBanked(await bankRaw(alertId));
                    } catch (err) {
                        onError(newsroomError(err, 'Could not bank this Raw.'));
                    } finally {
                        dispatch(setPopupLoading(false));
                        dispatch(handleHidePopup());
                    }
                },
                onCancel: () => dispatch(handleHidePopup()),
            })
        );
        dispatch(handleShowPopup());
    };
};

// The journalist changed their mind: the Raw goes back before its 24 hours are up.
export const useUnbankRaw = () => {
    const dispatch = useDispatch();

    return (bankId, { onUnbanked, onError }) => {
        dispatch(
            setPopupConfig({
                title: 'Unbank this Raw?',
                body: UNBANK_COPY,
                confirmTitle: 'Unbank it',
                cancelTitle: 'Keep it',
                onConfirm: async () => {
                    dispatch(setPopupLoading(true));
                    try {
                        await unbankRaw(bankId);
                        onUnbanked();
                    } catch (err) {
                        onError(
                            newsroomError(err, 'Could not unbank this Raw.')
                        );
                    } finally {
                        dispatch(setPopupLoading(false));
                        dispatch(handleHidePopup());
                    }
                },
                onCancel: () => dispatch(handleHidePopup()),
            })
        );
        dispatch(handleShowPopup());
    };
};
